import * as React from 'react'
import { Outlet } from 'react-router-dom'
import { Box } from '@mui/material'
import { DeliveryDateProvider } from 'contexts/deliveryDateContext'
import { OrdersProvider } from 'contexts/ordersContext'
import Header from './Header'
import Footer from './Footer'

/**
 * Layout component that serves as the main wrapper for the application.
 */
const Layout = () => {
  return (
    <DeliveryDateProvider>
      <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', backgroundColor: 'grey.100' }}>
        <Header />
        <Box sx={{ flex: 1 }}>
          <OrdersProvider>
            <Outlet />
          </OrdersProvider>
        </Box>
        <Footer />
      </Box>
    </DeliveryDateProvider>
  )
}

export default Layout
